/**
 * Suggest-Suche.
 * @typedef {{suggest: string, amount: number}} Suggest - Ein einzelner Suggest
 */
SP.lang.Class.define("SP.sitekit.search.Suggest", {

	extend: "SP.sitekit.search.Service",

	_el: null,

	_input: null,

	_suggestEl: null,

	_suggestList: null,

	_minLength: 3,

	_suggestionCount: 5,

	_suggestDataListUniqueId: null,

	_originalSearchTerm: "",

	_currentSelectionIndex: -1,

	_disabled: false,

	/**
	 * Konstruktor
	 * @param {HTMLElement} el
	 * @param {object} data
	 */
	init: function(el, data) {
		var me = this;
		me._super(data);

		me._suggestDataListUniqueId = this._generateId();

		if (SP.dom.Element.matches(el, 'input')) {
			me._input = el;

			var orignalParent = el.parentElement;

			/*
			 * Input und direkte Nachbar-Elemente werden in eine
			 * neuen Container gewrapped, damit eine barrierefreie
			 * Auszeichnung möglich ist
			 */
			var wrapper = document.createElement('div');

			// CSS-Klasse eigentlich nur als Indikator was hier passiert
			wrapper.classList.add('SP-Suggest-gen__fallbackWrapper');
			wrapper.style.display = "contents";
			orignalParent.insertBefore(wrapper, el);

			var x = orignalParent.children;
			for (var i = 0; i < x.length; i++) {
				var child = x.item(i);
				if (child !== wrapper) {
					wrapper.appendChild(child);
				}
			}
			me._el = wrapper;
		} else {
			me._el = el;
			me._input = el.querySelector("input");
		}

		me._originalSearchTerm = me._input.value;

		me._input.addEventListener("keydown", me.onKeyDown.bind(me));
		me._input.addEventListener("input", me.onInput.bind(me));
		me._input.addEventListener("focus", me._selectInputText.bind(me));
		me._input.addEventListener("blur", function () {
			setTimeout(function () {
				me.clearSuggest();
			}, 300);
		});

		// 'Schnittstelle', damit der SiteSearchController
		// über das Element Filter für die Suggest-Funktion setzen kann
		me._el.suggestInstance = me;

		me._el.setAttribute("role", "combobox");
		me._el.setAttribute("aria-expanded", "false");
		me._el.setAttribute("aria-haspopup", "listbox");
		me._el.setAttribute("aria-owns", this._suggestDataListUniqueId);

		me._input.setAttribute("autocomplete", "off");
		me._input.setAttribute("aria-autocomplete", "both");
		me._input.setAttribute("aria-controls", this._suggestDataListUniqueId);

		this._throttledSuggest = SP.lang.Function.throttle(this.callSuggest, this.suggestionTimeout || 400);

		this._selectInputText();
		this._createSuggestEl();
	},

	_selectInputText: function () {
		this._input.setSelectionRange(0, this._input.value.length);
	},

	selectNextSuggestion: function () {
		this.selectSuggestion(this._currentSelectionIndex + 1);
	},

	selectPreviousSuggestion: function () {
		this.selectSuggestion(this._currentSelectionIndex - 1);
	},

	selectFirstSuggestion: function () {
		this.selectSuggestion(0);
	},

	selectLastSuggestion: function () {
		this.selectSuggestion(this._suggestList.childElementCount - 1);
	},

	isSuggestVisible: function () {
		return this._suggestEl.hidden === false;
	},

	showSuggest: function () {
		this._el.setAttribute('aria-expanded', 'true');
		this._suggestEl.removeAttribute('hidden');
		this._suggestEl.classList.remove('hidden');
	},

	hideSuggest: function () {
		this._el.setAttribute("aria-expanded", "false");
		this._el.removeAttribute("aria-activedescendant");
		this._suggestEl.setAttribute('hidden', 'hidden');
		this._suggestEl.classList.add('hidden');
	},

	disable: function () {
		this._disabled = true;
		this.hideSuggest();
	},

	enable: function () {
		this._disabled = false;
	},

	/**
	 * @param {number} index
	 */
	selectSuggestion: function (index) {
		/** @type {HTMLUListElement} */
		var list = this._suggestList;
		var children = list.children;

		var correctedIndex = index;
		if (index >= children.length) {
			correctedIndex = 0;
		} else if (index < 0) {
			correctedIndex = children.length - 1;
		}
		this._currentSelectionIndex = correctedIndex;

		var selectedChild = children.item(correctedIndex);
		for (var i = 0; i < children.length; i++) {
			/** @type {HTMLElement} */
			var item = children.item(i);
			if (item !== selectedChild) {
				item.setAttribute('aria-selected', "false");
				item.classList.remove('active');
			} else {
				item.setAttribute('aria-selected', "true");
				item.classList.add('active');
				this._input.setAttribute('aria-activedescendant', item.id);
				this._input.value = item.getAttribute('data-suggest-keyword');
			}
		}
	},


	/**
	 * @returns string|null
	 */
	getCurrentKeyword: function () {
		var val = this._input.value.trim();
		if (val.length >= this._minLength) {
			return val;
		}
		return null;
	},

	/**
	 *
	 * @param {InputEvent} e
	 */
	onInput: function (e) {
		if (this._disabled) {
			return;
		}
		this._originalSearchTerm = this._input.value;
		var term = this.getCurrentKeyword();
		if (term) {
			this._throttledSuggest(term);
		} else {
			this.clearSuggest();
		}
	},

	/**
	 * @param {KeyboardEvent} e
	 */
	 onKeyDown: function(e) {
		if (this._disabled) {
			return;
		}
		switch(e.key) {
			case "ArrowUp":
			case "Up": // IE11
				e.preventDefault();
				this.selectPreviousSuggestion();
				break;
			case "ArrowDown":
			case "Down": // IE11
				e.preventDefault();
				this.selectNextSuggestion();
				break;
			case "Enter":
				this.clearSuggest();
				break;
			case "Escape":
			case "Esc": // IE11
				e.preventDefault();
				e.stopPropagation();
				if (this.isSuggestVisible()) {
					this._input.value = this._originalSearchTerm;
					this.clearSuggest();
				}
				break;
		}
	},

	/**
	 * @param {Suggest} suggest
	 * @param {number} index
	 * @return HTMLLIElement
	 */
	_renderSuggestItem: function (suggest, index) {
		var item = document.createElement('li');
		item.className = "SP-Suggest__item";
		item.id = "SP-Suggest-entry-" + index;
		item.setAttribute('role', 'option');
		item.setAttribute('data-suggest-keyword', suggest.suggest);

		var a = document.createElement('a');
		a.className ='SP-Suggest__link';
		a.setAttribute('role', 'presentation');
		a.tabIndex = -1;
		a.href = '#';
		item.appendChild(a);

		var query = document.createElement('span');
		query.className = 'SP-Suggest__query';
		query.innerHTML = suggest.suggest;
		a.appendChild(query);

		var amount = document.createElement('span');
		amount.className = "SP-Suggest__amount";
		amount.innerHTML = suggest.amount;
		a.appendChild(amount);

		return item;
	},

	_generateId: function() {
		return SP.generateId('SP-Suggest-gen');
	},

	_createSuggestEl: function () {
		var me = this;
		me._suggestEl = document.createElement('div');
		me._suggestEl.className = 'SP-Suggest__wrapper hidden';
		me._suggestEl.hidden = true;

		var suggestList = document.createElement('ul');
		suggestList.className = 'SP-Suggest';
		suggestList.setAttribute('role', 'listbox');
		suggestList.setAttribute('id', me._suggestDataListUniqueId);
		suggestList.addEventListener('click', me._handleItemClick.bind(me));

		var label = this._findLabelEl();
		if (label) {
			label.id = label.id || me._generateId();
			suggestList.setAttribute('aria-labelledby', label.id);
		}

		me._suggestList = suggestList;
		me._suggestEl.appendChild(me._suggestList);

		var afterElement = me._el.querySelector('.SP-Spellcheck') || me._input;
		afterElement.parentNode.insertBefore(me._suggestEl, afterElement.nextSibling);
	},

	_findLabelEl: function () {
		var inputId = this._input.id;
		if (!inputId) {
			return null;
		}
		return document.querySelector('label[for="' + inputId + '"]');
	},

	/**
	 *
	 * @param {PointerEvent} e
	 */
	_handleItemClick: function (e) {
		var item = SP.dom.Element.closest(e.target, '.SP-Suggest__item');
		if (!item) {
			return;
		}
		e.preventDefault();

		this._confirmSuggest(item);
	},

	_submitForm: function () {
		var form = this._input.form;
		if (form) {
			form.dispatchEvent(new CustomEvent("submit", {
				"bubbles": true,
				"cancelable": true
			}));
			form.submit();
		}
	},

	/**
	 *
	 * @param {HTMLLIElement} item
	 */
	_confirmSuggest: function (item) {
		var itemIndex = SP.lang.Array.from(this._suggestList.children).indexOf(item);
		this.selectSuggestion(itemIndex);
		this.clearSuggest();
		this._submitForm();
	},

	/**
	 * Rendert die initiale Suggest-Komponente
	 * @param {Suggest[]} suggests
	 */
	updateSuggestList: function (suggests) {
		var me = this;
		me.clearSuggest();
		if (suggests.length === 0) {
			return;
		}
		me.showSuggest();
		suggests.forEach(function (suggest, index) {
			me._suggestList.appendChild(me._renderSuggestItem(suggest, index));
		});
	},

	/**
	 * Führt die Anfrage für die Suggest-Suche durch
	 * @param {string} search
	 */
	callSuggest: function(search) {
		var me = this;
		me.suggest(search, {
			success: function(data) {
				var suggests = data.list;
				if (me._suggestionCount > 0) {
					suggests = data.list.slice(0, me._suggestionCount);
				}
				me.updateSuggestList(suggests);
			},
			failure: function(error) {
				console.error("ERROR: suggest", error);
			}
		});
	},


	clearSuggest: function () {
		this._currentSelectionIndex = -1;
		this._suggestList.innerHTML = '';
		this.hideSuggest();
	}

});
